import { Directive, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { RolesTypeEnum } from 'src/formio-custom-components/src/lib/shared/model/roles';
import { IFoData } from '../models/formIo-data';
import { visitInfo } from '../models/visit';

@Directive()
export class BaseComponent implements OnDestroy {
  destroy$ = new Subject<void>();
  @Input() visitInfo: visitInfo;
  @Input() id: string;
  @Input() data: IFoData;
  @Input() userRole: RolesTypeEnum;
  @Input() disabled: boolean;
  @Input() viewOnly: boolean;
  constructor() {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
